import React from 'react';

import { Box, Container, Grid, Typography } from '@material-ui/core';
import Rating from '@material-ui/lab/Rating';

import { useIsDesktop } from '../hooks/useBreakpoints';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockReviews } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockReviews>;

export const ReviewsBlock: React.FC<Props> = ({ block }) => {
  const { title, rating = 5, items = [] } = block;
  const classes = useBlockStyles(useStyles, block);
  const isDesktop = useIsDesktop();
  const reviews: BlockReviews['items'] = isDesktop ? items : [items?.[0]];
  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid
          container
          direction="column"
          alignItems="center"
          justifyContent="center"
          spacing={4}
        >
          <Grid item xs={12}>
            <Typography variant="h4" style={{ textAlign: 'center' }}>
              {title}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Rating value={rating} size="large" readOnly />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ flexGrow: 1, width: '100%', textAlign: 'center' }}
          >
            <Grid container justifyContent="space-around" spacing={2}>
              {reviews.map(({ title, content }, idx) => (
                <Grid item key={idx} xs={12} md={4}>
                  <Typography variant="h6">{title}</Typography>
                  <Typography variant="body2">{content}</Typography>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
